export function htmlOverlay(scene) {
    console.log('Adding HTML overlay to the scene');

    if (scene.currentPlanet !== 1) {
        return
    }

    // Disable Phaser input temporarily
    if (scene && scene.input) {
        scene.input.enabled = false;
    }

    // Create overlay container
    const overlay = document.createElement('div');
    overlay.id = 'tutorial-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.zIndex = '9999';
    overlay.style.pointerEvents = 'none'; // Allow positioning children independently
    document.body.appendChild(overlay);


    // Create mask (clickable area with cutout)
    const mask = document.createElement('div');
    mask.style.position = 'absolute';
    mask.style.top = '50%';
    mask.style.left = '50%';
    mask.style.width = '200px';
    mask.style.height = '200px';
    mask.style.marginTop = '-100px';
    mask.style.marginLeft = '-100px';
    //mask.style.border = '3px solid #FFD700';
    mask.style.borderRadius = '8px';
    mask.style.boxShadow = '0 0 0 9999px rgba(17, 4, 78, 0.5), 0 0 20px rgba(17, 4, 78, 0.8), inset 0 0 20px rgba(255, 215, 0, 0.3)';
    mask.style.pointerEvents = 'auto'; // This allows clicks in the mask area
    mask.style.cursor = 'pointer';
    mask.style.animation = 'tutorial-pulse 2s infinite';
    overlay.appendChild(mask);

    // Handle click on mask
    mask.addEventListener('click', (e) => {
        console.log('Mask clicked!');

        // Get the position of the click relative to the mask
        const rect = mask.getBoundingClientRect();

        // Find what's underneath the mask and forward the click
        // Temporarily hide the overlay to check what's beneath
        overlay.style.display = 'none';
        const elementBelow = document.elementFromPoint(
            rect.left + rect.width / 2,
            rect.top + rect.height / 2
        );
        overlay.style.display = 'block';

        if (elementBelow) {
            // Dispatch click event to element below
            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
                clientX: rect.left + rect.width / 2,
                clientY: rect.top + rect.height / 2
            });
            elementBelow.dispatchEvent(clickEvent);
        }

    });

    // Function to remove the overlay
    function removeOverlay() {

        if (scene.currentPlanet !== 1) {
            return
        }
        // Re-enable Phaser input
        if (scene && scene.input) {
            scene.input.enabled = true;
        }
        overlay.remove();
    }

    // Return utility object for updating mask position
    return {
        // Update mask position to target a specific element
        setTarget: (targetSelector) => {
            const target = document.querySelector(targetSelector) ||
                document.getElementById(targetSelector);

            if (target) {
                const rect = target.getBoundingClientRect();
                mask.style.top = rect.top + 'px';
                mask.style.left = rect.left + 'px';
                mask.style.width = rect.width + 'px';
                mask.style.height = rect.height + 'px';
                mask.style.marginTop = '0';
                mask.style.marginLeft = '0';
                mask.style.borderRadius = '8px';

            }
        },

        // Target a Phaser game object by coordinates
        setTargetByCoords: (x, y, width, height) => {
            mask.style.top = y + 'px';
            mask.style.left = x + 'px';
            mask.style.width = width + 'px';
            mask.style.height = height + 'px';
            mask.style.marginTop = '0';
            mask.style.marginLeft = '0';


            // Re-enable input only for objects within the mask area
            if (scene && scene.input) {
                scene.input.enabled = true;

                // Store original hitArea check
                const originalProcessPointer = scene.input.hitTest;

                // Override hit test to only allow clicks within mask bounds
                scene.input.hitTest = function (pointer, gameObjects, camera) {
                    const maskBounds = {
                        x: x,
                        y: y,
                        right: x + width,
                        bottom: y + height
                    };

                    // Check if pointer is within mask
                    if (pointer.x >= maskBounds.x &&
                        pointer.x <= maskBounds.right &&
                        pointer.y >= maskBounds.y &&
                        pointer.y <= maskBounds.bottom) {
                        return originalProcessPointer.call(this, pointer, gameObjects, camera);
                    }

                    return [];
                };
            }
        },

        // Update tooltip text
        setText: (text) => {
            // tooltip.textContent = text;
        },

        // Remove the overlay
        remove: removeOverlay,

        // Get the overlay element
        element: overlay
    };
}



export function phaserOverlay(scene) {
    console.log('Adding Phaser overlay to the scene');

    if (scene.currentPlanet !== 1) {
        return
    }

    // Create container for all overlay elements
    const container = scene.add.container(0, 0);
    const OVERLAY_DEPTH = 10000;
    container.setDepth(OVERLAY_DEPTH);

    // Create graphics for the overlay
    const graphics = scene.add.graphics();
    graphics.setDepth(OVERLAY_DEPTH);
    container.add(graphics);

    // Create border graphics for the mask highlight
    const borderGraphics = scene.add.graphics();
    borderGraphics.setDepth(OVERLAY_DEPTH + 1);
    container.add(borderGraphics);

    // Store disabled objects and mask bounds
    let disabledObjects = [];
    let maskBoundsArray = []; // Now stores multiple mask bounds

    // Check if a point/bounds intersects with any mask
    function intersectsAnyMask(bounds) {
        return maskBoundsArray.some(mask => {
            return !(
                bounds.x + bounds.width < mask.x ||
                bounds.x > mask.x + mask.width ||
                bounds.y + bounds.height < mask.y ||
                bounds.y > mask.y + mask.height
            );
        });
    }

    // Disable input for all interactive objects outside masks
    function disableInputOutsideMask() {
        disabledObjects = [];

        // Get all game objects in the scene
        const allObjects = scene.children.list;

        if (!allObjects || !Array.isArray(allObjects)) return;

        allObjects.forEach(obj => {
            if (!obj.input) return;

            const bounds = obj.getBounds ? obj.getBounds() : {
                x: obj.x - (obj.width || 0) / 2,
                y: obj.y - (obj.height || 0) / 2,
                width: obj.width || 0,
                height: obj.height || 0
            };

            // Check if object intersects with any mask
            if (!intersectsAnyMask(bounds)) {
                obj.disableInteractive();
                disabledObjects.push(obj);
            }
        });
    }

    // Draw a single cutout with rounded corners
    function drawCutoutCorners(x, y, width, height, radius) {
        // Top-left corner
        graphics.beginPath();
        graphics.moveTo(x, y);
        graphics.lineTo(x, y + radius);
        graphics.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 1.5, false);
        graphics.lineTo(x, y);
        graphics.closePath();
        graphics.fillPath();

        // Top-right corner
        graphics.beginPath();
        graphics.moveTo(x + width, y);
        graphics.lineTo(x + width - radius, y);
        graphics.arc(x + width - radius, y + radius, radius, -Math.PI / 2, 0, false);
        graphics.lineTo(x + width, y);
        graphics.closePath();
        graphics.fillPath();

        // Bottom-left corner
        graphics.beginPath();
        graphics.moveTo(x, y + height);
        graphics.lineTo(x + radius, y + height);
        graphics.arc(x + radius, y + height - radius, radius, Math.PI / 2, Math.PI, false);
        graphics.lineTo(x, y + height);
        graphics.closePath();
        graphics.fillPath();

        // Bottom-right corner
        graphics.beginPath();
        graphics.moveTo(x + width, y + height);
        graphics.lineTo(x + width, y + height - radius);
        graphics.arc(x + width - radius, y + height - radius, radius, 0, Math.PI / 2, false);
        graphics.lineTo(x + width, y + height);
        graphics.closePath();
        graphics.fillPath();
    }

    // Function to remove the overlay
    function removeOverlay() {
        if (scene.currentPlanet !== 1) {
            return
        }

        // Re-enable disabled objects
        if (disabledObjects) {
            disabledObjects.forEach(obj => {
                if (obj && obj.setInteractive) {
                    obj.setInteractive();
                }
            });
        }

        // Destroy all overlay elements
        if (container) {
            container.destroy();
        }
    }

    return {
        // Set target with single cutout (backward compatible)
        setTargetByCoords: (x, y, width, height, radius = 8) => {
            maskBoundsArray = [{ x, y, width, height }];

            const screenWidth = scene.scale.width;
            const screenHeight = scene.scale.height;

            graphics.clear();
            graphics.fillStyle(0x11044E, 0.5);

            // Draw the 4 rectangles around the mask
            // Top
            graphics.fillRect(0, 0, screenWidth, y);
            // Left
            graphics.fillRect(0, y, x, height);
            // Right  
            graphics.fillRect(x + width, y, screenWidth - (x + width), height);
            // Bottom
            graphics.fillRect(0, y + height, screenWidth, screenHeight - (y + height));

            // Fill corners for rounded effect
            drawCutoutCorners(x, y, width, height, radius);

            borderGraphics.clear();

            // Disable input outside mask
            disableInputOutsideMask();
        },

        // Set multiple cutouts
        setMultipleCutouts: (cutouts) => {
            // cutouts is an array of {x, y, width, height, radius}
            maskBoundsArray = cutouts.map(c => ({ x: c.x, y: c.y, width: c.width, height: c.height }));

            const screenWidth = scene.scale.width;
            const screenHeight = scene.scale.height;

            graphics.clear();
            graphics.fillStyle(0x11044E, 0.5);

            // Create a grid of horizontal slices to properly handle overlapping cutouts
            const yCoords = new Set([0, screenHeight]);
            cutouts.forEach(cutout => {
                yCoords.add(cutout.y);
                yCoords.add(cutout.y + cutout.height);
            });
            const sortedYCoords = Array.from(yCoords).sort((a, b) => a - b);

            // For each horizontal slice, determine what to draw
            for (let i = 0; i < sortedYCoords.length - 1; i++) {
                const sliceY = sortedYCoords[i];
                const sliceHeight = sortedYCoords[i + 1] - sliceY;

                // Find all cutouts that intersect this slice
                const intersectingCutouts = cutouts.filter(cutout => {
                    return cutout.y < sliceY + sliceHeight && cutout.y + cutout.height > sliceY;
                });

                if (intersectingCutouts.length === 0) {
                    // No cutouts in this slice, fill the entire width
                    graphics.fillRect(0, sliceY, screenWidth, sliceHeight);
                } else {
                    // Sort cutouts by x position
                    const sortedCutouts = intersectingCutouts.sort((a, b) => a.x - b.x);

                    // Draw left edge (before first cutout)
                    graphics.fillRect(0, sliceY, sortedCutouts[0].x, sliceHeight);

                    // Draw between cutouts
                    for (let j = 0; j < sortedCutouts.length - 1; j++) {
                        const current = sortedCutouts[j];
                        const next = sortedCutouts[j + 1];
                        const gapX = current.x + current.width;
                        const gapWidth = next.x - gapX;
                        if (gapWidth > 0) {
                            graphics.fillRect(gapX, sliceY, gapWidth, sliceHeight);
                        }
                    }

                    // Draw right edge (after last cutout)
                    const lastCutout = sortedCutouts[sortedCutouts.length - 1];
                    const rightX = lastCutout.x + lastCutout.width;
                    graphics.fillRect(rightX, sliceY, screenWidth - rightX, sliceHeight);
                }
            }

            // Draw rounded corners for each cutout
            cutouts.forEach(cutout => {
                const radius = cutout.radius || 8;
                drawCutoutCorners(cutout.x, cutout.y, cutout.width, cutout.height, radius);
            });

            borderGraphics.clear();

            // Disable input outside masks
            disableInputOutsideMask();
        },

        // Set specific game objects to appear above the overlay
        setAboveOverlay: (objects, depth = null) => {
            const targetDepth = depth || (OVERLAY_DEPTH + 10);

            if (Array.isArray(objects)) {
                objects.forEach(obj => {
                    if (obj && obj.setDepth) {
                        obj.setDepth(targetDepth);
                    }
                });
            } else {
                if (objects && objects.setDepth) {
                    objects.setDepth(targetDepth);
                }
            }
        },

        setBelowOverlay: (objects, depth = null) => {
            const targetDepth = depth || (OVERLAY_DEPTH - 10);

            if (Array.isArray(objects)) {
                objects.forEach(obj => {
                    if (obj && obj.setDepth) {
                        obj.setDepth(targetDepth);
                    }
                });
            } else {
                if (objects && objects.setDepth) {
                    objects.setDepth(targetDepth);
                }
            }
        },

        // Remove the overlay
        remove: removeOverlay,

        // Get the container element
        element: container
    };
}